import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { compose } from "recompose";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withStyles, useTheme } from "@material-ui/core/styles";
import Add from "@material-ui/icons/Add";
import { showModal } from "../../../redux/actions";
import CreateCircleModal from "./CreateCircleModal";

const styles = {
  root: {
    background: "black",
  },
  input: {
    color: "white",
    backgroundColor: "rgb(36, 48, 65)",
  },
};

const AddCircleButton = ({ onCreateClick, intl }) => {
  const theme = useTheme();

  return (
    <Button variant="contained" color="primary" onClick={() => onCreateClick()}>
      <Add
        style={{
          color: "white",
          marginRight: "5px",
          fontSize: "18px",
          fontWeight: "700",
        }}
      />
      {intl.formatMessage({ id: "app.circles.createCircleButton" })}
    </Button>
  );
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch, ownProps) => ({
  onCreateClick: () => dispatch(showModal(CreateCircleModal)),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  withStyles(styles),
);

export default enhance(AddCircleButton);
